export default "__VITE_ASSET__DQzeeYF6__"